import { Checkbox, FormControlLabel, Grid } from '@freighthub/silhouette-core'
import { useObserver } from 'mobx-react-lite'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { TLegalEntity } from './LegalEntitiesModel'

export type DefaultForIntegrationsProps = {
  legalEntity: TLegalEntity
}

export const DefaultForIntegrations: FC<DefaultForIntegrationsProps> = ({ legalEntity }) => {
  const { translate } = useI18n()

  return useObserver(() => (
    <Grid xs={12}>
      <Grid xs={12}>
        <FormControlLabel
          label={translate('directory-default_for_integrations_legal_entity')}
          control={
            <Checkbox
              checked={legalEntity.defaultForIntegrations.value}
              onChange={(e) => {
                legalEntity.setDefaultForIntegrations(e.target.checked)
              }}
              data-testid="default-for-integrations-checkbox"
            />
          }
        />
        <div>{translate('directory-default_for_integrations_legal_entity-description')}</div>
      </Grid>
    </Grid>
  ))
}
